// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Custom Turbo Stream action: dispatch a custom DOM event
// Usage: <turbo-stream action="dispatch_event" event="eventName" detail='{"key":"value"}'>
import { StreamActions } from "@hotwired/turbo"

StreamActions.dispatch_event = function() {
  const eventName = this.getAttribute("event")
  let detail = {}
  try { detail = JSON.parse(this.getAttribute("detail") || "{}") } catch (e) { /* ignore malformed JSON */ }
  window.dispatchEvent(new CustomEvent(eventName, { detail }))
}

// Custom Turbo Stream action: close a modal
// Usage: turbo_stream.action(:close_modal, "modal-id")
StreamActions.close_modal = function() {
  this.targetElements.forEach(element => {
    element.innerHTML = ""
    element.classList.add("hidden")
  })
  document.body.classList.remove("overflow-hidden")
}

// Custom Turbo Stream action: redirect to a URL
// Usage: turbo_stream.action(:redirect, "/path")
StreamActions.redirect = function() {
  Turbo.visit(this.target)
}
